import { type } from './type.js';

/**
 * @description
 * Checks if `value` is a `plain object`, that is, an object created by the Object constructor or one with a [[Prototype]] of null.
 *
 * @example
 * ``` ts
 * isPlainObject({ array: [] });
 * // => true
 * isPlainObject({});
 * // => true
 * isPlainObject(new A());
 * // => false
 * isPlainObject(null);
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns true if value is a plain object, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-plain-object
 */
export const isPlainObject = (value): boolean => {
  if (type(value) !== 'object') {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return prototype === null || prototype === Object.prototype;
};
